import { Badge, Box, Button, HStack, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { FaBicycle, FaCar, FaWalking } from "react-icons/fa";
import { MdDirectionsTransit } from "react-icons/md";
import { useUITheme } from "../../context/ThemeContext";

const MODES = [
  ["walking", "Walk", FaWalking],
  ["bicycling", "Cycle", FaBicycle],
  ["transit", "Public", MdDirectionsTransit],
  ["driving", "Taxi", FaCar],
];
const COLORS = { walking: "#4285f4", bicycling: "#0d9488", transit: "#7c3aed", driving: "#ea580c" };

export default function RouteLegModal({ leg, index, isOpen, onClose, onModeChange, changing }) {
  const theme = useUITheme();
  if (!leg) return null;
  const active = MODES.find(([id]) => id === leg.mode) || MODES[0];
  const ActiveIcon = active[2];
  return <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom" scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent position="fixed" bottom={0} m={0} w={{ base: "100%", md: "520px" }} maxW="100%" maxH="78dvh" bg={theme.bg} color={theme.text} borderTopRadius="3xl">
      <ModalHeader><HStack><Box bg={COLORS[leg.mode]} color="white" borderRadius="full" boxSize="48px" display="grid" placeItems="center"><ActiveIcon /></Box><Box><Text fontSize="xs" color={COLORS[leg.mode]} letterSpacing="0.12em">LEG {index + 1}</Text><Text fontSize="xl">{active[1]}</Text><Text fontSize="sm" fontWeight="normal" opacity={0.65}>{leg.duration} · {leg.distance}</Text></Box></HStack></ModalHeader>
      <ModalBody pb="calc(env(safe-area-inset-bottom, 0px) + 24px)">
        <SimpleGrid columns={4} spacing={1} border={`1px solid ${theme.accent}`} borderRadius="xl" p={1}>
          {MODES.map(([id, label, Icon]) => <Button key={id} size="xs" px={1} leftIcon={<Icon />} isLoading={changing === id} bg={leg.mode === id ? COLORS[id] : "transparent"} color={leg.mode === id ? "white" : theme.text} onClick={() => onModeChange(id)}>{label}</Button>)}
        </SimpleGrid>
        <Text fontSize="xs" opacity={0.65} mt={2}>Choose another mode to recalculate only this part of your itinerary.</Text>
        {leg.mode === "transit" && <Button mt={2} size="sm" variant="outline" colorScheme="purple" isLoading={changing === "transit"} onClick={() => onModeChange("transit")}>Refresh live times</Button>}
        <VStack align="stretch" mt={4} spacing={2}>
          {(leg.steps || []).map((step, stepIndex) => <Box key={stepIndex} border={`1px solid ${theme.accent}`} bg={`${theme.accent}12`} borderRadius="xl" p={3}>
            <Text fontWeight="bold">{step.instruction || "Continue on the route"}</Text>
            {step.line && <Badge mt={1} colorScheme="purple">{step.vehicle ? `${step.vehicle} · ` : ""}{step.line}</Badge>}
            {(step.departureStop || step.arrivalStop) && <Text fontSize="sm" mt={1}>{step.departureStop || "Board"} → {step.arrivalStop || "Alight"}</Text>}
            <Text fontSize="xs" opacity={0.65} mt={1}>{step.duration} · {step.distance}</Text>
          </Box>)}
        </VStack>
      </ModalBody>
    </ModalContent>
  </Modal>;
}
